/* For Omada Design Hub */
(function () {
  const statusEl = document.getElementById('odh-cart-status');
  const statusText = statusEl ? statusEl.querySelector('.odh-cart-status__text') : null;

  function setError(message) {
    if (!statusText) return;
    statusText.textContent = message;
    statusEl.classList.add('odh-cart-status--error');
  }

  async function run() {
    const params = new URLSearchParams(window.location.search);
    const itemsParam = params.get('items');       // e.g. "43416662671459:2,43416662966371:4"
    const projectName = params.get('projectName'); // human-readable label
    const projectId = params.get('project_id') || projectName; // fallback if ODH doesn't send a separate id
    const discount = params.get('discount');

    if (!itemsParam || !projectName) {
      setError('Something went wrong. Please return to Omada Design Hub and try again.');
      return;
    }

    let items;
    try {
      items = itemsParam.split(',').map(function (pair) {
        const parts = pair.split(':');
        const id = parts[0];
        const quantity = parseInt(parts[1], 10);
        if (!id || !quantity || quantity < 1) throw new Error('bad pair');
        return {
          id: id,
          quantity: quantity,
          properties: {
            _project_id: projectId,
            Project: projectName
          }
        };
      });
    } catch (e) {
      setError('Something went wrong. Please return to ODH and try again.');
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (!res.ok) {
        const err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || 'Cart add failed');
      }
    } catch (e) {
      setError('Something went wrong. Please try again or contact support.');
      return;
    }

    if (discount) {
      window.location.href = '/discount/' + encodeURIComponent(discount) + '?redirect=/checkout';
    } else {
      window.location.href = '/checkout';
    }
  }

  run();
})();